import SearchBoxDropdown from './SearchBoxDropdown';
import getSuggestionCalloutContent from './suggestionsCallout/getSuggestionCalloutContent';
import onSuggestionsCalloutDismissed from '../actions/onSuggestionsCalloutDismissed';
import onSuggestionsCalloutPositioned from '../actions/onSuggestionsCalloutPositioned';
import onSuggestionsCalloutWillUnmount from '../actions/onSuggestionsCalloutWillUnmount';
import { SUGGESTIONS_CALLOUT_ID } from '../constants';
import getScenarioStore from '../store/getScenarioStore';
import getSubstrateSearchScenarioBySearchScenarioId from '../utils/getSubstrateSearchScenarioBySearchScenarioId';
import { observer } from 'mobx-react';
import { SEARCHBOX_ID, SearchScenarioId } from 'owa-search-next-common';
import { lazyLogResponseRendered, SuggestionSet } from 'owa-search-service';
import * as React from 'react';

export interface SuggestionsCalloutProps {
    scenarioId: SearchScenarioId;
}

@observer
export default class SuggestionsCallout extends React.Component<SuggestionsCalloutProps, {}> {
    private suggestions: JSX.Element[] = [];

    componentWillUnmount() {
        onSuggestionsCalloutWillUnmount(this.props.scenarioId);
    }

    render() {
        const { scenarioId } = this.props;
        const { currentSuggestions: suggestionSet } = getScenarioStore(scenarioId);

        // Don't render anything if there aren't any suggestions.
        if ((suggestionSet && suggestionSet.Suggestions.length === 0) || !suggestionSet) {
            return null;
        }

        return (
            <SearchBoxDropdown
                content={this.renderSuggestionCalloutContent(suggestionSet, scenarioId)}
                id={SUGGESTIONS_CALLOUT_ID}
                onPositioned={this.onPositioned}
                role="listbox"
                setInitialFocus={false}
                scenarioId={scenarioId}
                onDismiss={this.onDismiss}
                targetId={SEARCHBOX_ID}
            />
        );
    }

    /**
     * Helper function to get JSX of suggestion set to be displayed. Also takes
     * care of logging to 3S that the suggestion set was rendered.
     */
    private renderSuggestionCalloutContent(
        suggestionSet: SuggestionSet,
        scenarioId: SearchScenarioId
    ) {
        /**
         * Cache existing items (if new suggestions are still in progress) to be
         * returned if new suggestions aren't ready to be displayed.
         */
        let content: JSX.Element[] = this.suggestions;

        /**
         * Get current suggestions from store and see if they're ready to be
         * displayed. If so, create the new callout content using those suggestions.
         * If not, return current set of suggestions being displayed.
         */
        if (suggestionSet.IsComplete) {
            content = getSuggestionCalloutContent(suggestionSet, scenarioId);

            // Log response rendered (if 3S) and we have a trace ID from 3S.
            if (getScenarioStore(scenarioId).isUsing3S && suggestionSet.TraceId) {
                lazyLogResponseRendered.importAndExecute(
                    suggestionSet.TraceId,
                    new Date(),
                    getSubstrateSearchScenarioBySearchScenarioId(scenarioId)
                );
            }
        }

        return <div role="listbox">{content}</div>;
    }

    private onDismiss = () => {
        onSuggestionsCalloutDismissed(this.props.scenarioId);
    };

    /**
     * onPositioned handler when the callout gets correctly positioned.
     */
    private onPositioned = () => {
        onSuggestionsCalloutPositioned(this.props.scenarioId);
    };
}
